module.exports = __webpack_public_path__ + "img/mouse_left_button.d2d5897f.svg";